import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgCheckmark = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M20.21 6.79a1 1 0 0 0-1.42 0l-9.29 9.3-4.29-4.3a1.004 1.004 0 1 0-1.42 1.42l5 5a1.001 1.001 0 0 0 1.42 0l10-10a1 1 0 0 0 0-1.42Z" />
  )
export default SvgCheckmark
